<template>
    <div class="bg-color rounded-5 p-5">
        <div class="w-100 rounded-4">
            <div
                class="d-flex justify-content-between"
                style="background: rgb(241, 247, 255); border-radius: 27px 27px 0 0"
            >
                <div class="flex align-items-center list-page-header">
                    <h1 class="px-5 py-3 page-heading">Dashboard Build History</h1>
                    <div class="list-search">
                        <input type="text" v-model="searchTextRaw" placeholder="Search dashboard" />
                    </div>
                </div>
                <button class="text-button no-bg weight-600" style="margin-right: 10px; background: transparent">
                    <router-link class="text-link margin-0" :to="{ name: 'DashboardBuilder' }">
                        <img src="@/assets/px/add.png" alt="" style="height: 20px" /> Create new dashboard
                    </router-link>
                </button>
            </div>
            <div class="w-100 bg-white" v-if="!template_list">
                <div class="d-grid justify-content-center align-items-center py-5" style="min-height: 400px">
                    <h4>Fetching information...</h4>
                </div>
            </div>
            <div
                v-else-if="template_list.length > 0"
                class="dashboard-list-table profile-listing-body pb-2"
                style="width: 82vw"
            >
                <b-table
                    id="my-table"
                    :items="template_list.slice().reverse()"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    bordered
                    responsive
                >
                    <template #cell(s_no)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(company_name)>
                        {{ companyName }}
                    </template>
                    <template #cell(dashboard_name)="row">
                        <span :id="`dashboardName-${row.index}`" class="column-ellipsis">
                            {{ row.item.dashboardName }}
                        </span>
                        <b-tooltip :target="`dashboardName-${row.index}`" triggers="hover" placement="bottom">
                            {{ row.item.dashboardName }}
                        </b-tooltip>
                    </template>
                    <template #cell(application)="row">
                        <span :id="`application-${row.index}`" class="column-ellipsis">
                            {{ formatPortalName(row.item.application) }}
                        </span>
                        <b-tooltip :target="`application-${row.index}`" triggers="hover" placement="bottom">
                            {{ formatPortalName(row.item.application) }}
                        </b-tooltip>
                    </template>
                    <template #cell(status)="row">
                        <span
                            :style="{
                                color: row.item.status === 'draft' ? '#FF991F' : '#0c9',
                                'font-weight': '600',
                            }"
                            >{{ row.item.status }}</span
                        >
                    </template>
                    <template #cell(created_at)="row">
                        {{ formattedDate(row.item.created_at) }}
                    </template>
                    <template #cell(modified_at)="row">
                        {{ formattedDate(row.item.updated_at) }}
                    </template>
                    <template #cell(action)="row">
                        <div class="d-flex justify-content-center align-items-center" style="gap: 10px">
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Language Translate"
                                :target="`#translate-${row.index}`"
                                cssClass="customtooltip"
                            >
                                <img
                                    src="@/assets/px/language-translate.svg"
                                    alt=""
                                    style="height: 20px"
                                    :id="`translate-${row.index}`"
                                    :style="{
                                        cursor:
                                            !['kiosk', 'mobex-health-plus', 'mobex-health-home'].includes(row.item.application) || row.item.status === 'draft'
                                                ? 'not-allowed'
                                                : 'pointer',
                                        opacity:
                                            !['kiosk', 'mobex-health-plus', 'mobex-health-home'].includes(row.item.application) || row.item.status === 'draft'
                                                ? '0.5'
                                                : '1',
                                    }"
                                    @click="gotoLanguageTranslation(row.item)"
                                />
                            </ejs-tooltip>
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Duplicate"
                                :target="`#duplicate-${row.index}`"
                                cssClass="customtooltip"
                            >
                                <img
                                    src="@/assets/px/duplicate.png"
                                    alt=""
                                    style="height: 20px"
                                    :id="`duplicate-${row.index}`"
                                    @click="openDashboardCloneModal(row.item)"
                                    :style="{ cursor: row.item.status === 'draft' ? 'not-allowed' : 'pointer' }"
                                />
                            </ejs-tooltip>
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Edit"
                                :target="`#edit-${row.index}`"
                                cssClass="customtooltip"
                            >
                                <img
                                    src="@/assets/px/edit-icon.png"
                                    alt=""
                                    style="height: 20px; cursor: pointer"
                                    :id="`edit-${row.index}`"
                                    @click="editDashboard(row.item)"
                                />
                            </ejs-tooltip>
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Delete"
                                :target="`#delete-${row.index}`"
                                cssClass="customtooltip"
                            >
                                <img
                                    src="@/assets/px/delete-icon.png"
                                    alt=""
                                    style="height: 20px; cursor: pointer"
                                    :id="`delete-${row.index}`"
                                    @click="showDeleteAlertPopUp(row.item.id)"
                                />
                            </ejs-tooltip>
                        </div>
                    </template>
                </b-table>
                <div class="b-table-pagination">
                    <div class="pagination-count-per-page">
                        <div class="pagination-number-per-page">
                            <div>
                                <span>Per page:</span>
                            </div>
                            <div>
                                <select style="" @change="changeCountPerPage" :value="perPage">
                                    <option v-for="item in perPageOptions" :key="item" :value="item">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <b-pagination
                        align="right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                    ></b-pagination>
                </div>
            </div>
            <div class="w-100 bg-white" v-else>
                <div class="d-grid justify-content-center align-items-center py-5" style="min-height: 400px">
                    <h4>No dashboard found</h4>
                </div>
            </div>
            <div class="profile-delete-modal">
                <AlertDeleteDashboardTemplate
                    v-if="showDeleteAlert"
                    :open="showDeleteAlert"
                    @cancel="showDeleteAlert = false"
                    @handleDelete="handleDelete"
                />
                <CloneDashboardModal
                    v-if="showCloneDashboard"
                    :dashboardDetails="dashboardDetails"
                    @cancel="closeDashboardCloneModal"
                />
            </div>
        </div>
        <Loading v-if="loading" />
    </div>
</template>
<script>
    import AlertDeleteDashboardTemplate from './DeleteTemplateAlert';
    import CloneDashboardModal from './CloneDashboardModal.vue';
    import Loading from '@/components/general/loading/loading.vue';
    import dayjs from '@/util/dayjs';
    import { memberProfile, dashboardBuilder } from '@/util/apiRequests';
    import { Roles } from '@/util/globalConstants';
    import { tryGetFilter } from '@/util/tryGetFilter';
    import { debounce } from 'lodash';
    import { formatPortalName } from '@/util/genericUtilityFunctions';
    import axios from 'axios';

    export default {
        name: 'DashboardList',
        components: {
            AlertDeleteDashboardTemplate,
            CloneDashboardModal,
            Loading,
        },
        data() {
            return {
                current_step: 2,
                max_step: 4,
                template_list: null,
                showDeleteAlert: false,
                indexTodelete: null,
                checked: true,
                fields: [
                    { key: 's_no', label: 'S NO.', thStyle: { 'padding-left': '0 !important' }, class: 'table-col' },
                    { key: 'company_name', label: 'Company Name', class: 'table-col' },
                    { key: 'dashboard_name', label: 'Dashboard Name', class: 'table-col' },
                    { key: 'application', label: 'Application', class: 'table-col' },
                    { key: 'status', label: 'Status', class: 'table-col' },
                    { key: 'created_at', label: 'Created Date & Time', class: 'table-col' },
                    { key: 'created_by', label: 'Created By', class: 'table-col' },
                    { key: 'modified_at', label: 'Modified Date & Time', class: 'table-col' },
                    { key: 'updated_by', label: 'Modified By', class: 'table-col' },
                    { key: 'action', label: 'Action', class: 'action-sticky', stickyColumn: true, isRowHeader: true },
                ],
                searchTextRaw: '',
                totalRows: 0,

                // b-table properties
                storeKey: 'dashboards',
                perPageOptions: [5, 10, 20, 50, 100],
                currentPage: 1,
                perPage: 10,
                totalxRows: null,
                showCloneDashboard: false,
                dashboardDetails: null,
                loading: true,
                companyName: null,
                cancelTokenSource: null,
            };
        },
        computed: {
            userIsSuperAdmin() {
                if (this.$store.state.user.role_id == Roles.SUPER_ADMIN) {
                    return true;
                } else return false;
            },
            rows() {
                return this.totalRows;
            },
        },
        methods: {
            formatPortalName(name) {
                return formatPortalName(name);
            },
            async get_company() {
                let companyId = this.$store.state.user.company_id;
                const res = await this.$api.get(`/company/getCompany/${companyId}`);
                this.companyName = res.data.info[0].company_name;
            },
            async getTemplateList() {
                try {
                    let list = await this.$api.get(dashboardBuilder.getTemplateList());
                    let data = list.data.templateMetaList;
                    this.template_list = data;
                    this.totalRows = data.length;
                } catch (err) {
                    this.$toasted.error('Failed to fetched Dashboards');
                } finally {
                    this.loading = false;
                }
            },
            async deleteModuleandSubModule(id) {
                try {
                    let data = await this.$api.delete(memberProfile.deleteModuleAndSubModules(id));
                } catch (e) {
                    const errorMessage = e ? e : 'Failed to delete module and its submodule !';
                    this.$toasted.error(errorMessage);
                }
            },
            async assignDashboardToAll(dashboardId, info) {
                try {
                    let data = await this.$api.put(dashboardBuilder.assignDashboardToAll(dashboardId), { info });
                } catch (e) {
                    const errorMessage = e ? e : 'Failed to assign dashboard to all members !';
                    this.$toasted.error(errorMessage);
                }
            },
            debounceSearch: debounce(async function () {
                this.loading = true;

                if (!this.searchTextRaw.trim()) {
                    await this.getTemplateList();
                    this.currentPage = 1;
                    this.loading = false;
                    return;
                }

                try {
                    if (this.cancelTokenSource) {
                        this.cancelTokenSource.cancel('Previous request canceled');
                    }
                    this.cancelTokenSource = axios.CancelToken.source();

                    const response = await this.$api.post(
                        dashboardBuilder.getSearchedDashboard(),
                        {
                            dashboard_name: this.searchTextRaw.trim(),
                        },
                        {
                            cancelToken: this.cancelTokenSource.token,
                        }
                    );
                    if (!response) return;

                    if (response.data && response.data.success && Array.isArray(response.data.response)) {
                        this.template_list = response.data.response;
                        this.totalRows = response.data.response.length;
                    } else {
                        this.template_list = [];
                        this.totalRows = 0;
                    }

                    this.currentPage = 1;
                } catch (error) {
                    this.$toasted.error('Failed to search dashboards');
                    console.log('Search error:', error);
                    this.getTemplateList();
                } finally {
                    this.loading = false;
                }
            }, 500),
            formattedDate(date) {
                return date ? dayjs(date).format('MM/DD/YYYY hh:mmA') : '';
            },
            showDeleteAlertPopUp(id) {
                this.showDeleteAlert = true;
                this.indexTodelete = id;
            },
            openDashboardCloneModal(value) {
                if (value.status === 'draft') {
                    return;
                }
                this.dashboardDetails = value;
                this.showCloneDashboard = true;
                document.body.style.overflow = 'hidden';
            },
            closeDashboardCloneModal() {
                this.dashboardDetails = null;
                this.showCloneDashboard = false;
                document.body.style.overflow = 'auto';
            },

            async cloneDashboard(dashboardName) {
                if (dashboardName == '') {
                    return this.$toasted.error('Dashboard Name is Required');
                } else {
                    try {
                        const response = await this.$api.post(dashboardBuilder.checkDashboardName(), {
                            dashboardName: dashboardName,
                        });
                        if (!response?.data.success) {
                            return this.$toasted.error('Dashboard with this name Already exits');
                        }
                        const res = await this.$api.post(dashboardBuilder.copyDashboard(this.dashboardDetails), {
                            name: dashboardName,
                        });
                        if (res?.data?.success) {
                            this.$router.push({
                                name: 'DashboardBuilder',
                                query: { id: res?.data?.response, status: 'completed' },
                                replace: true,
                            });
                        }
                    } catch {
                        this.$toasted.error('Failed to clone Dashboard');
                    }
                    this.showCloneDashboard = false;
                    this.dashboardDetails = null;
                }
            },

            async handleDelete() {
                try {
                    this.showDeleteAlert = true;
                    let response = await this.$api.delete(dashboardBuilder.deleteTemplate(this.indexTodelete));
                    const { success, clientsUsingDashboard, applicationsUsingDashboard } = response.data;
                    this.showDeleteAlert = false;

                    if (!success) {
                        if (clientsUsingDashboard != undefined) {
                            this.$toasted.error(
                                `Dashboard can't deleted as it is assigned to ${clientsUsingDashboard} user(s)!`
                            );
                        } else {
                            this.$toasted.error(
                                `Dashboard can't be deleted as it is assigned to ${applicationsUsingDashboard} application(s)!`
                            );
                        }
                        return;
                    }
                    this.deleteModuleandSubModule(this.indexTodelete);
                    this.getTemplateList();
                    this.$toasted.success('Dashboard is deleted successfully !');
                } catch (e) {
                    const errorMessage = e ? e : 'Failed to delete member profile !';
                    this.$toasted.error(errorMessage);
                }

                this.showDeleteAlert = false;
            },
            changeCountPerPage({ target: { value } }) {
                this.perPage = Number(value);
            },
            savedPagination() {
                const previousPagination = tryGetFilter(this.$store, this.storeKey);
                this.currentPage = previousPagination.currentPage ?? 1;
                this.perPage = previousPagination.perPage ?? 10;
            },
            async editDashboard(value) {
                const { id, status } = value;
                if (status === 'draft') {
                    this.$router.push({ name: 'DashboardBuilder', query: { id, status } });
                } else {
                    this.loading = true;
                    const isDashboardInUpdatingStatus = await this.getDashboardUpdatingStatus(id);
                    if (isDashboardInUpdatingStatus) {
                        this.loading = false;
                        this.$toasted.error(
                            'The Dashboard is currently being updated by another user, please try again later'
                        );
                    } else {
                        this.$router.push({ name: 'DashboardBuilder', query: { id, status } });
                    }
                }
            },
            gotoLanguageTranslation(data) {
                const { id, application, status } = data;
                if (!['kiosk', 'mobex-health-plus', 'mobex-health-home'].includes(application) || status === 'draft') {
                    return;
                }
                this.$router.push({ name: 'LanguageTranslation', query: { id } });
            },
            async getDashboardUpdatingStatus(id) {
                try {
                    const endpoint = dashboardBuilder.getDashboardUpdatingStatus(id);
                    const res = await this.$api.get(endpoint);
                    return res?.data?.data?.in_update_state;
                } catch (err) {
                    this.$toasted.error('Failed to get dashboard update state');
                }
                return 0;
            },
        },
        async created() {
            this.savedPagination();
            await this.get_company();
            await this.getTemplateList();
        },
        watch: {
            searchTextRaw() {
                this.debounceSearch();
            },
            currentPage: function (val) {
                this.$store.commit('filters/updateFilter', {
                    stateKey: this.storeKey,
                    criteria: {
                        perPage: Number(this.perPage),
                        currentPage: Number(val),
                    },
                });
            },
            perPage: function (val) {
                this.$store.commit('filters/updateFilter', {
                    stateKey: this.storeKey,
                    criteria: {
                        currentPage: Number(this.currentPage),
                        perPage: Number(val),
                    },
                });
            },
        },
    };
</script>

<style scoped>
    .bg-color {
        background-color: rgba(255, 255, 255, 0.9);
    }

    .text-button a,
    .text-button a:hover,
    .text-button:hover {
        background-color: #5057c3;
        color: white;
        padding: 10px;
        border-radius: 10px;
    }

    .list-page-header {
        display: block;
        margin: 0;
        padding: 0;
        background: none;
    }
</style>

<style>
    .dashboard-list-table table tbody tr > td:first-child {
        padding-left: 2.5em !important;
    }

    .dashboard-list-table .b-table-sticky-column:last-child {
        right: 0;
        min-width: 100px;
    }

    .dashboard-list-table .action-sticky {
        min-width: 150px;
        box-shadow: -10px 0px 10px 1px #aaaaaa;
    }

    .dashboard-list-table .table-col {
        max-width: 150px;
        text-overflow: ellipsis;
        text-wrap: nowrap;
    }
</style>
